import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';

const HeaderStyles = styled.header`
  border-bottom: 1px solid var(--gray);
  display: flex;
  justify-content: space-between;

  padding: 1rem 2rem;

  nav {
    display: flex;

    a + a {
      margin-left: 2rem;
    }
  }

  a {
    text-decoration: none;
    color: var(--black);
    transition: all 0.1s ease;
    font-family: var(--heading-fonts);
    text-transform: uppercase;
    font-weight: 700;
  }
  a:hover {
    color: var(--pop);
  }

  #name {
    font-family: var(--name-font);
    text-transform: uppercase;
    font-size: 1.5rem;
    font-weight: 300;
  }

  @media screen and (max-width: 769px) {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 2fr 1fr;
    justify-content: center;

    nav {
      display: flex;
      justify-content: space-between;
    }

    #name {
      text-align: center;
    }
  }
`;

export default function Header() {
  return (
    <HeaderStyles>
      <Link to="/" id="name">
        Clay Carlson
      </Link>
      <nav>
        <Link to="/research">Research</Link>
        <Link to="/writing">Writing</Link>
        <Link to="/speaking">Speaking</Link>
        <Link to="/courses">Courses</Link>
        <Link to="/contact">Contact</Link>
      </nav>
    </HeaderStyles>
  );
}
